const WinlosesTypes = {
    FETCH_START:    '[FOOD] FETCH START',
    FETCH_SUCCESS:  '[FOOD] FETCH SUCCESS',
    FETCH_FAILURE:  '[FOOD] FETCH FAILURE'
};

export default WinlosesTypes;